import React, { useCallback, useState } from "react";

import { Button, Flex, Typography } from "antd";
import { useDispatch } from "react-redux";

import { useTranslation } from "react-i18next";

import { AuthActions } from "../../../../auth/actions";

import useTimer from "../../../../hooks/useTimer";

function SuccessRestorePasswordView() {
  const [version, setVersion] = useState(0);
  const { t } = useTranslation("translations");
  const dispatch = useDispatch();

  const { minutes, seconds, secondsLeft } = useTimer(60, version);

  const handleResendRestorePassword = useCallback(() => {
    dispatch(AuthActions.resendRestorePassword());
    setVersion((x) => x + 1);
  }, [dispatch]);

  return (
    <Flex vertical align="flex-start" gap="middle">
      <Typography.Text>{t("drop_password_email_sent")}</Typography.Text>
      {secondsLeft > 0 && (
        <Typography.Text type="secondary">
          {t("resending_possible_after")} {minutes}:{seconds}
        </Typography.Text>
      )}
      <Button type="text" onClick={handleResendRestorePassword} disabled={secondsLeft > 0}>
        {t("send_email_again")}
      </Button>
    </Flex>
  );
}

export default React.memo(SuccessRestorePasswordView);
